<template lang="pug">
.pt-XS
  BriqExpansionPanel
    template(slot="header")
      .flex
        .title-and-description-wrapper
          .title {{ title }}
          .subtitle {{ subtitle }}
        .status-wrapper.flex.justify-center.align-center
          .status(
            :class="statusColor" 
            :data-test-id="`${slugify(title)}-status-title`"
            )  {{ statusTitle }}
          .status-subtitle {{ statusSubtitle }}
    template(slot="content")
      .content
        .p-XS
          slot
</template>

<script>
import slugify from '@/helpers/slugify.js'
import BriqExpansionPanel from '@v/components/BriqExpansionPanel.vue'

export default {
  name: 'ProductPricingAccordion',
  components: { BriqExpansionPanel },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    statusColor: {
      type: String,
      validator(val) {
        return ['green', 'gray', 'red'].includes(val)
      },
    },
    statusTitle: { type: String, required: true },
    statusSubtitle: String,
  },
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    slugify,
  },
}
</script>

<style scoped lang="stylus">
.border-bottom
  border-bottom 1px solid #ececec

.title-and-description-wrapper
  width 78%

  .title
    font-weight 500
    font-size 16px
    line-height 24px

  .subtitle
    font-weight 400
    font-size 12px
    line-height 24px
    color #798696

.status-wrapper
  width 20%
  flex-direction column

  .status
    background #D3D3D3
    border-radius 2px
    padding 4px 8px
    color #121D32
    font-weight 500

  .status-subtitle
    font-weight 400
    font-size 12px
    line-height 24px
    color #798696

  .green
    background #3E9E00
    color #FFF

  .gray
    background #d3d3d3
    color #121d32

  .red
    background #e93838
    color #FFF

.content
  background-color #EFF3F7
</style>
